import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
import moment from "moment";
import "moment-timezone";
import momentTz from "moment-timezone";

// Currently we are using cst - central standard time
// const timeZone = "America/Regina";
const timestampFormat = "MM/DD/yyyy, hh:mm A z";

/**
 * This to get the timestamp
 * @params  first -  Date Object | ISO string
 * @params  second - optional
 *
 **/
const getTimeZoneTimeStamp = (timeZone: any, date: any, options?: any) => {
  // Ensure the date is correctly interpreted in PST
  const pstTime = moment.tz(date, "America/Los_Angeles");
  // Convert PST time to timestamp (milliseconds)
  return pstTime.valueOf();
  //return utcToZonedTime(date, timeZone, options).valueOf()
};

/**
 * This to get the user readble format to show in component
 * @params first-  use getTimeZoneTimeStamp()
 * @params second - yyyy-MM-dd HH:mm:ss zzz example
 **/
const getFormatedDate = (
  timeZone: any,
  formatedDate: number,
  formatString?: string
) => {
  // const utcTime = zonedTimeToUtc(formatedDate, timeZone)
  // console.log('utcTime',utcTime)
  // const timezoneTime = moment(utcTime)

  // 	?.tz(timeZone)
  // 	?.format(formatString || timestampFormat)
  // 	console.log('timezoneTime',timezoneTime)
  // return timezoneTime

  // Interpret the date as already in PST
  const pstTime = moment.tz(formatedDate, "America/Los_Angeles");

  // Convert and return in required format (no UTC conversion)
  const formattedTime = pstTime.tz(timeZone).format(formatString);

  return formattedTime;
  // return format(formatedDate, formatString || defaultFormat, {
  //   timeZone: timeZone,
  // });
};

//function to append time abbreviation after timestamp
export const appendTimezoneWithoutConversion = (
  date: string,
  plantTZ: string
): string => {
  const formattedDate = moment.utc(date).format("MM/DD/YYYY hh:mm A");
  const timezoneAbbr = momentTz.tz(plantTZ).zoneAbbr();

  return `${formattedDate} ${timezoneAbbr}`;
};

export { getFormatedDate, getTimeZoneTimeStamp };
